export enum BusinessDayStartHour {
  gas = 6,
  power = 0,
}
